// extracted by mini-css-extract-plugin
export default {"wrapper":"localmultiplayerintroduction_wrapper__Tx7Mo","button":"localmultiplayerintroduction_button__ssMn2"};